// @flow
import React from 'react';
import PropTypes from 'prop-types';

import icons from '../../../assets/styles/icons.scss';

type Props = {
  +name?: string;
  +field?: string;
  +label?: string;
  +value: string;
  // name is the name of the input, and field the semantic group
  +handleDelete: (name?: string, field?: string) => void;
};

const Tag = ({ name, field, label, value, handleDelete }: Props) => (
  <li>
    <article>
      <span>{label}</span>
      <button type="button"
              onClick={_ => handleDelete(name, value)}>
        <i className={icons.iconCloseMedium}/>
      </button>
    </article>
  </li>
);

Tag.propTypes = {
  name: PropTypes.string,
  field: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default Tag;




// WEBPACK FOOTER //
// ./src/elements/Filter/Tag/Tag.jsx